import de from "./de-DE.json";
import en from "./en-GB.json";
import es from "./es-ES.json";
import fr from "./fr-FR.json";
import hu from "./hu-HU.json";
import it from "./it-IT.json";
import no from "./nn-NO.json";
import pt from "./pt-PT.json";
import ro from "./ro-RO.json";
import sk from "./sk-SK.json";

const messages = {
  de,
  en,
  es,
  fr,
  hu,
  it,
  no,
  pt,
  ro,
  sk
};

export default messages;